﻿module.exports = (function ($) {
	return {
		init: function () {
			if($('.eventHeroMap').length > 0){
				this.initHero();
			}
		},
		initHero: function () {
			var self = this;
			var category = $('.eventHeroMap').attr('data-category')
			var long = $('.eventHeroMap').attr('data-long');
			var lat = $('.eventHeroMap').attr('data-lat');
			var pinInfo = {
				latitude: lat,
				longitude: long,
				category: category
			}
			self.createMap(pinInfo);
		},
		createMarker: function (map, pinInfo) {
			// Init markers
			var marker;

			// Get all the filtered events/resources results and and lat/long
			var iconUrl = window.location.protocol + '//' + window.location.hostname;
			// get type of result and set pin.
			switch (pinInfo.category.toLowerCase()) {
				case "bushfire":
					iconUrl += "/assets/images/maps/bushfire-pin.png";
					break;
				case "flood":
					iconUrl += "/assets/images/maps/bushfire-pin.png";
					break;
				case "earthquake":
					iconUrl += "/assets/images/maps/bushfire-pin.png";
					break;
				case "storm":
					iconUrl += "/assets/images/maps/bushfire-pin.png";
					break;
				case "road accident":
					iconUrl += "/assets/images/maps/bushfire-pin.png";
					break;
				case "chemical spill":
					iconUrl += "/assets/images/maps/bushfire-pin.png";
					break;
				default:
					iconUrl += "/assets/images/maps/bushfire-pin.png";
					break;
			}

			// Create a new marker.
			if (pinInfo) {
				var latLng = new google.maps.LatLng(pinInfo.latitude, pinInfo.longitude);
				marker = new google.maps.Marker({
					position: latLng,
					map: map,
					icon: iconUrl // Get a custom one made
				});
			}

			return marker;
		},
		createMap: function (pinInfo) {

			var self = this;

			var mapOptions = {
				zoom: 7,
				disableDefaultUI: true,
				center: new google.maps.LatLng(pinInfo.latitude, pinInfo.longitude), // center on pin
				styles: [
							{
								"featureType": "administrative",
								"elementType": "geometry",
								"stylers": [
									{
										"visibility": "off"
									},
									{
										"color": "#95aabb"
									}
								]
							},
							{
								"featureType": "administrative",
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"color": "#444444"
									}
								]
							},
							{
								"featureType": "administrative.province",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "administrative.province",
								"elementType": "geometry.stroke",
								"stylers": [
									{
										"visibility": "on"
									},
									{
										"color": "#ababab"
									}
								]
							},
							{
								"featureType": "administrative.land_parcel",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "landscape",
								"elementType": "all",
								"stylers": [
									{
										"color": "#f2f2f2"
									}
								]
							},
							{
								"featureType": "landscape",
								"elementType": "labels.text",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "landscape.man_made",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "landscape.man_made",
								"elementType": "geometry",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "landscape.man_made",
								"elementType": "labels",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "landscape.natural.terrain",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#f2f2f2"
									}
								]
							},
							{
								"featureType": "poi",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "road",
								"elementType": "all",
								"stylers": [
									{
										"saturation": -100
									},
									{
										"lightness": 45
									},
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "on"
									},
									{
										"weight": "1"
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "geometry.fill",
								"stylers": [
									{
										"visibility": "simplified"
									},
									{
										"weight": "1.5"
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "geometry.stroke",
								"stylers": [
									{
										"visibility": "simplified"
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "labels",
								"stylers": [
									{
										"visibility": "simplified"
									},
									{
										"weight": "0.25"
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "labels.icon",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "road.arterial",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "off"
									},
									{
										"weight": "1.15"
									}
								]
							},
							{
								"featureType": "road.arterial",
								"elementType": "labels.icon",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "road.local",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "transit",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "water",
								"elementType": "all",
								"stylers": [
									{
										"color": "#46bcec"
									},
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "water",
								"elementType": "geometry",
								"stylers": [
									{
										"visibility": "on"
									},
									{
										"color": "#95aabb"
									}
								]
							},
							{
								"featureType": "water",
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"visibility": "on"
									},
									{
										"color": "#ffffff"
									}
								]
							}
				]
			};

			// Set up google map
			var map = new google.maps.Map(document.getElementById("google-map-bg"), mapOptions);

			google.maps.event.addDomListener(window, 'resize', function () {
				var center = map.getCenter();
				google.maps.event.trigger(map, "resize");
				map.setCenter(center);
			});

			var marker = self.createMarker(map, pinInfo);
		},
	};
});